export default __webpack_public_path__ + "static/media/SideDrawerClose.66c6f271.svg";